export const isEventPosition = (position) => ['actions', 'entity'].includes(position);
export const isEventType = (type) => ['navigate', 'persist', 'delete', 'redirectOnPersist'].includes(type);
export const isCreateScope = (scope) => scope.type === 'create';
export const isDetailScope = (scope) => scope.type === 'detail';
export const isDataGridScope = (scope) => scope.type === 'dataGrid';
export const isEditScope = (scope) => scope.type === 'edit';
export const isPluginScope = (scope) => scope.type === 'plugin';
export const isMultiEditScope = (scope) => scope.type === 'multiEdit';
export const isUniqueScope = (scope) => scope.type === 'unique';
export const isNavigateEvent = (event) => event?.type === 'navigate';
export const isEntityEvent = (event) => event?.position === 'entity';
export const isPersistEvent = (event) => event?.type === 'persist';
export const isRedirectOnPersistEvent = (event) => event?.type === 'redirectOnPersist';
export const isDeleteEvent = (event) => event?.type === 'delete';
export function getDefaultFieldType(field) {
    switch (field.type) {
        case 'Bool':
            return 'checkbox';
        case 'Integer':
        case 'Double':
            return 'number';
        case 'Date':
            return 'date';
        case 'DateTime':
            return 'datetime';
        case 'Enum':
            return 'radio';
        case 'OneHasMany':
            return 'repeater';
        case 'OneHasOne':
        case 'ManyHasOne':
            return 'select';
        case 'ManyHasMany':
            return 'multiselect';
        default:
            return 'text';
    }
}
export function getDefaultColumnType(field) {
    switch (field.type) {
        case 'Bool':
            return 'boolean';
        case 'Integer':
        case 'Double':
            return 'number';
        case 'Date':
            return 'date';
        case 'DateTime':
            return 'datetime';
        case 'Enum':
            return 'enum';
        case 'OneHasMany':
        case 'ManyHasMany':
            return 'hasMany';
        case 'OneHasOne':
        case 'ManyHasOne':
            return 'hasOne';
        default:
            return 'text';
    }
}
export const removeSurroundingQuotes = (value) => {
    return value.replace(/^"(.*)"$/, '$1');
};
//# sourceMappingURL=helpers.js.map